<script lang="ts">
  import { Usp } from '@stickerapp-org/athena/Usp';

  import { PageSection } from '@athena-lib/Page';
  import { storyblokEditable } from '@storyblok/svelte';
  import type { MaybeResponsive } from '@athena-lib/responsive-utils';
  import { Column, Columns } from '@athena-lib/Columns';
  import clsx from 'clsx';
  import type { PageSectionBackground } from '@athena-lib/container-context.svelte';
  import { alignClasses } from './shared/page-section-utils';
  import type { ExpandedUspPageSectionBlock } from '$lib/server/expanders/uspPageSectionExpander';
  const { blok }: { blok: ExpandedUspPageSectionBlock } = $props();

  const responsiveBackground: MaybeResponsive<PageSectionBackground> = $derived({
    lg: blok.desktopBackgroundColor ?? 'light',
    md: blok.desktopBackgroundColor ?? 'light',
    sm: blok.mobileBackgroundColor ?? 'light',
  });
  const usps = $derived(blok.expandedUsps);

  const uspClass = $derived.by(() =>
    [
      blok.mobileAlignment ? alignClasses['mobile'][blok.mobileAlignment] : '',
      blok.desktopAlignment ? alignClasses['desktop'][blok.desktopAlignment] : '',
    ].join(' '),
  );
</script>

<PageSection
  id={blok.elementId}
  action={storyblokEditable}
  actionArg={blok}
  backgroundColor={responsiveBackground}
  ySpace={{ top: blok.topPadding ?? 'medium', bottom: blok.bottomPadding ?? 'medium' }}
>
  <Columns
    collapseBelow="md"
    space="xxlarge"
    class={clsx('px-6', blok.desktopIconOverText && 'md:px-10')}
  >
    {#each usps as usp}
      <Column>
        <Usp
          alignment={{
            sm: blok.mobileAlignment ?? 'center',
            md: blok.desktopAlignment ?? 'center',
            lg: blok.desktopAlignment ?? 'center',
          }}
          iconAbove={{
            sm: blok.mobileIconOverText ?? false,
            md: blok.desktopIconOverText ?? false,
            lg: blok.desktopIconOverText ?? false,
          }}
          class={uspClass}
          heading={usp.heading ?? ''}
          text={usp.text ?? ''}
          image={{ src: usp.icon?.filename, alt: usp.icon?.alt }}
        />
      </Column>
    {/each}
  </Columns>
</PageSection>
